import React, { forwardRef } from 'react';

import { Checkbox } from '@vlabs/uikit/components/controls/checkbox';

import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';
import { StreamStatusValue } from '@vlabs/monokit/shared/ui/stream-statuses/types';

import { useSourceFilters } from '../useSourceFilters';
import st from './popovers.module.sass';
import { STATUS_LABEL_KEYS } from '../constants';

const STATUS_VALUES = Object.values(StreamStatusValue)
  .filter((value): value is StreamStatusValue => typeof value === 'number');

function StatusFilterPopover(
  {
    ...props
  }: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { filters, updateFilters } = useSourceFilters();
  const selectedStatuses = filters.statuses ?? [];

  const onToggleStatus = (status: number, checked: boolean) => {
    const nextStatuses = checked
      ? [...selectedStatuses, status]
      : selectedStatuses.filter((value) => value !== status);

    updateFilters({
      statuses: nextStatuses.length > 0 ? nextStatuses : undefined,
      page: 1,
    });
  };

  const reset = () => updateFilters({ statuses: undefined, page: 1 });

  return (
    <PopoverWithButton
      {...props}
      data-testid="stream-statuses"
      onClickReset={reset}
      ref={ref}
    >
      <div className={st.OptionsList}>
        {STATUS_VALUES.map((status) => (
          <Checkbox
            checked={selectedStatuses.includes(status)}
            key={status}
            label={STATUS_LABEL_KEYS[status]}
            onChangeValue={(checked) => onToggleStatus(status, checked)}
          />
        ))}
      </div>
    </PopoverWithButton>
  );
}

export default forwardRef(StatusFilterPopover);
